import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from '../../assets/student-main-tab.module.scss';
import InfoItem from '../../../../components/InfoItem';
import RenderFile from 'src/components/RenderFile';
import user from 'src/services/user-auth';
import { changeToZeroMoment } from 'src/helpers/timeHelpers';
import { IStudent } from 'src/types/student';

export interface StateProps {
    programBooks: any;
    files: any;
}
export interface DispatchProps {}

export interface OwnProps {
    student: Partial<IStudent> | null;
    tab?: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}
const StudentInfo: React.FunctionComponent<Props> = ({ programBooks, student, files }: Props) => {
    if (!student) {
        return null;
    }

    const {
        id,
        firstName,
        lastName,
        code,
        address,
        parentFirstName,
        parentLastName,
        parentPrimaryEmail,
        parentSecondaryEmail,
        parentPhone,
        attorneyFullName,
        attorneyPrimaryEmail,
        attorneySecondaryEmail,
        attorneyPhoneNumber,
        status,
        orderDoc,
        orderDocName,
        orderDocMimeType,
        dob,
        consentDocMimeType,
        consentDoc,
        consentDocName,
        parentConsentDocMimeType,
        parentConsentDoc,
        parentConsentDocName,
    } = student;
    const userRole: Array<string> = user.getRoles();

    const studentStatuses: any = user.getStudentAvailableStatus();
    let statusName = '';
    Object.keys(studentStatuses).forEach((it: any) => {
        if (status === studentStatuses[it]) {
            statusName = `${it}`;
        }
    });
    const orderDocFiles = [];
    if (orderDoc) {
        const orderDocFile = {
            attach: orderDoc,
            mimeType: orderDocMimeType,
            name: orderDocName,
        };
        orderDocFiles.push(orderDocFile);
    }
    const consentDocFiles = [];
    if (consentDoc) {
        const consentDocFile = {
            attach: consentDoc,
            mimeType: consentDocMimeType,
            name: consentDocName,
        };
        consentDocFiles.push(consentDocFile);
    }

    const parentConsentDocFiles = [];
    if (parentConsentDoc) {
        const authConsentDocFile = {
            attach: parentConsentDoc,
            mimeType: parentConsentDocMimeType,
            name: parentConsentDocName,
        };
        parentConsentDocFiles.push(authConsentDocFile);
    }

    const previewFiles = (data: any) =>
        data &&
        data.map((file: any, i: number) => (
            <li style={{ listStyleType: 'none' }} key={file.attach}>
                <a rel="noopener noreferrer" target="_blank" href={`${file.attach}`}>
                    <RenderFile file={file} />
                </a>
            </li>
        ));

    const previewProgramBooks = (data: any) =>
        data &&
        data?.data?.list &&
        data.data.list.map((item: any, i: number) => (
            <Link
                key={i + 'pgb'}
                to={Router.generate(routes.PROGRAM_BOOK_DETAIL, {
                    id: item.id,
                })}
                type={'button'}
                className={'btn btn-outline-info mr-2'}
                target={'_blank'}
            >
                Program Book id={item.id}
            </Link>
        ));

    return (
        <div className={classNames(styles.infoWrap)}>
            <div className={classNames(styles.infoItems)}>
                <b className={classNames(styles.groupTitle)}>Student Details</b>
                <div className={classNames(styles.infoItemsBox)}>
                    <InfoItem title={'First Name:'} value={firstName} />
                    <InfoItem title={'Last Name:'} value={lastName} />
                    <InfoItem title={'Student ID:'} value={code} />
                    <InfoItem title={'Address:'} value={address} />
                    <InfoItem title={'Date of birth:'} value={dob ? changeToZeroMoment(dob, 'MMM D, YYYY') : ''} />
                    <InfoItem title={'Status:'} value={statusName} />
                </div>

                <b className={classNames(styles.groupTitle)}>Parent Details</b>
                <div className={classNames(styles.infoItemsBox)}>
                    <InfoItem title={'First Name:'} value={parentFirstName} />
                    <InfoItem title={'Last Name:'} value={parentLastName} />
                    <InfoItem title={'Primary Email:'} value={parentPrimaryEmail} />
                    <InfoItem title={'Secondary Email(s):'} value={parentSecondaryEmail} />
                    <InfoItem
                        title={'Phone:'}
                        value={
                            <a rel="noopener noreferrer" target="_blank" href={`tel:${parentPhone}`}>
                                {parentPhone}
                            </a>
                        }
                    />
                </div>

                <b className={classNames(styles.groupTitle)}>Attorney Details</b>
                <div className={classNames(styles.infoItemsBox)}>
                    <InfoItem title={'Name:'} value={attorneyFullName} />
                    <InfoItem title={'Primary Email:'} value={attorneyPrimaryEmail} />
                    <InfoItem title={'Secondary Email(s):'} value={attorneySecondaryEmail} />
                    <InfoItem
                        title={'Phone:'}
                        value={
                            <a rel="noopener noreferrer" target="_blank" href={`tel:${attorneyPhoneNumber}`}>
                                {attorneyPhoneNumber}
                            </a>
                        }
                    />
                </div>

                <b className={classNames(styles.groupTitle)}>Documents</b>
                <div className={classNames(styles.infoItemsBox)}>
                    <InfoItem title={'The Order:'} value={previewFiles(orderDocFiles)} />
                    <InfoItem title={'Parent consent for telehealth services:'} value={previewFiles(consentDocFiles)} />
                    <InfoItem
                        title={'Parent consent for authorization change:'}
                        value={previewFiles(parentConsentDocFiles)}
                    />
                    <InfoItem title={'Other Supporting Documents:'} value={previewFiles(files)} />
                </div>

                <b className={classNames(styles.groupTitle)}>Program Books</b>
                <div className={classNames(styles.infoItemsBox, styles.programBook)}>
                    <InfoItem title={' '} value={previewProgramBooks(programBooks)} />
                </div>
            </div>
            {userRole.map((i) =>
                i === 'ROLE_ADMIN' ? (
                    <div key={i + 'userROLE'}>
                        <Link
                            className={classNames('btn', 'btn-outline-secondary')}
                            to={Router.generate(routes.STUDENT_EDIT, { id })}
                        >
                            EDIT
                        </Link>
                    </div>
                ) : null,
            )}
        </div>
    );
};

export default StudentInfo;
